/**
 * Analytics (AN) — the read-only Manager pilotage surface FeatureModule. One screen under /analytics:
 *
 *   /analytics  — the dashboard tableau: live current-day KPI tiles (TAT / volume / revenue / qc /
 *                 reagent) with rapport tone bands, a YTD/3-mo/12-mo period bascule driving a Recharts
 *                 trend line over the snapshot history, and the referral federation tile (hidden when
 *                 the referral module is unmounted, D-28).
 *
 * The module is READ-ONLY (no write/create/update action). Audit-on-read fires server-side on every
 * dashboard read. deployClass HYBRID — mounts on a local install; if a future cloud-only surface
 * 404s, the screen renders a clean "not available on this install" state.
 *
 * Gating. Both server routes are gated on analytics.tableau.view, so we gate the whole module (and the
 * single nav item) on that exact key. ProtectedRoute enforces it on the route; the server re-checks
 * every request — useCan only hides/short-circuits UI.
 */
import type { FeatureModule } from "@/app";
import { ANALYTICS_CAPS, MODULE_CAPS } from "./caps";
import { registerAnalyticsMessages } from "./messages";
import { DashboardPage } from "./screens/DashboardPage";

const analyticsModule: FeatureModule = {
  id: "analytics",
  title: "Tableau analytique",
  requiredCapabilities: MODULE_CAPS,
  routes: [{ path: "/analytics", element: <DashboardPage /> }],
  nav: [
    {
      id: "analytics-tableau",
      path: "/analytics",
      label: "nav.analytics.tableau",
      icon: "◔",
      order: 5,
      section: "nav.section.analytics",
      requiredCapabilities: [ANALYTICS_CAPS.tableauView],
    },
  ],
  onRegister() {
    registerAnalyticsMessages();
  },
};

export default analyticsModule;
